import React from 'react'
import ClientsList from './ClientsList'
import OurProducts from './OurProducts'
import {OurProductsSecond} from './OurProducts'
import MainForm from './MainForm'

import PartnersList from './PartnersList'

import './styles/Home.scss'

import OurTeam from './OurTeam'

import headerImage from '../images/header-image.svg'

import {HashLink as Link} from 'react-router-hash-link'

import {BrowserView, MobileView, isBrowser, isMobile} from 'react-device-detect'

import {useContext} from 'react'
import PopupContext from '../context/popupContext'

import Form from './Form'

function Home() {
    const {currentPopup, setCurrentPopup} = useContext(PopupContext)

    const reviewContent = <MainForm/>

    const handleBackdropClick = () => {
        setCurrentPopup({content: currentPopup.content, isActive: false})
        setTimeout(() => {
            setCurrentPopup({content: '', isActive: false})
        }, 300)
    }

    return (
        <>
            <header>
                <div className="header__container">
                    <div className="header__text">
                        {isBrowser && <div className={'home-icons'}>
                            <img src="/images/icons/centre.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/ERP.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/Franch.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/Fresh.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/casplan.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/optimacros.png" width={200} height={100} alt=""/>
                        </div>}

                        <h1>Учим компьютеры помогать людям!</h1>


                        {/*<p className="main-text">*/}
                        {/*    КИБЕРНЕТИКА — это Консорциум ведущих отечественных ИТ-компаний, создающих «тяжелые» системы для корпоративного сектора на базе*/}
                        {/*    решений 1С. <br /> <br />*/}
                        {/*    Мы не боимся трудных проектов. Получаем удовольствие, когда удается облегчить нашим Клиентам жизнь с помощью магии информационных*/}
                        {/*    технологий.*/}
                        {/*</p>*/}

                        {/*<p className="main-text">*/}
                        {/*    Создаём фундамент для роста и лидерства вашего бизнеса в цифровую эпоху. <br/> <br/>*/}
                        {/*    Мы внедряем ERP системы, автоматизируем процессы бюджетирования, закупок, планирования*/}
                        {/*    производства, казначейства, wms, расчета зарплаты и кадрового учета, документооборота, учета*/}
                        {/*    автотранспорта и многие другие разделы управленческого учета на базе 1С Предприятие и не*/}
                        {/*    только.*/}
                        {/*</p>*/}

                        <p>Предоставляем полный спектр услуг для цифровой трансформации! <br/><br/>От интеграции с
                            оборудованием и датчиков до ERP систем, корпоративных систем планирования, документооборота,
                            мобильных приложений и AI ассистентов. <br/><br/>Готовые решения по всем основным задачам
                            возникающих у корпоративных заказчиков, ERP, WMS, CRM, CPM, TMS, MES, BI, DWH, ETL,
                            ABCosting, Казначейство, Консолидация, ЗУП, Бюджетирование, Закупки, ТОиР, интеграции
                            различных систем.</p>


                        {isMobile && <div className={'home-icons'}>
                            <img src="/images/icons/centre.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/ERP.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/Franch.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/Fresh.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/casplan.png" width={200} height={100} alt=""/>
                            <img src="/images/icons/optimacros.png" width={200} height={100} alt=""/>
                        </div>}

                    </div>

                    <button
                        onClick={(evt) => {
                            setCurrentPopup({content: reviewContent, isActive: true})
                        }}
                        className="btn"
                    >
                        Нажми!
                    </button>
                </div>

                {/* <div className="header__header-image"></div> */}
                {/* 
                {isMobile && (
                    <ClientsList />
                )} */}
                {isMobile && <ClientsList/>}

                <img src={headerImage} alt="" className="header__header-image"/>
            </header>

            {isBrowser && <ClientsList/>}

            <OurProductsSecond/>

            <div className="company-in-numbers">
                <div className="align-center">
                    <div>
                        <h2>Учим компьютеры помогать людям!</h2>
                        <p className="main-text">Авторские разработки на базе наших предыдущих проектов и опыт
                            специалистов с 20 летним стажем помогут вам получить гарантированный результат в сжатые
                            сроки.</p>


                    </div>
                    {/* <p className="main-text">
                        Lorem ipsum dolor sit amet consectetur. Ultricies enim lectus pharetra vitae posuere nulla scelerisque. Ipsum mauris volutpat urna
                        mauris purus tellus montes tortor sit.
                    </p> */}
                </div>

                <div className="company-in-numbers__list">
                    <div className="company-in-numbers__item">
                        <div className="company-in-numbers__number">19</div>
                        <div className="main-text">Продуктов</div>
                    </div>
                    <div className="company-in-numbers__hr"></div>
                    <div className="company-in-numbers__item">
                        <div className="company-in-numbers__number">60+</div>
                        <div className="main-text">Клиентов</div>
                    </div>
                    <div className="company-in-numbers__hr"></div>
                    <div className="company-in-numbers__item">
                        <div className="company-in-numbers__number">50+</div>
                        <div className="main-text">Сотрудников</div>
                    </div>
                </div>

                <p className="main-text tp-center">Синергия передовых технологий BI, систем планирования, ИИ и мобильных
                    решений с проверенными решениями от фирмы 1С даст вашему бизнесу конкурентное преимущество и поможет
                    стать эффективнее.</p>
            </div>

            <PartnersList/>

            <MainForm/>

            <OurTeam/>
        </>
    )
}

export default Home
